// extracted by mini-css-extract-plugin
export default {"wrapper":"breadcrumb_wrapper__klYlV","arrowRightIcon":"breadcrumb_arrowRightIcon__ZM6Ke","component":"breadcrumb_component__IA6OX"};